import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e99f2c0c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "TaskInfo"
}
const _hoisted_2 = { class: "title" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "left name" }
const _hoisted_5 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_6 = {
  key: 1,
  style: {"color":"blue"}
}
const _hoisted_7 = {
  key: 2,
  style: {"color":"green"}
}
const _hoisted_8 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_ctx.mfloorTaskStatus?.composite_task_list?.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_a_row, { gutter: 24 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 24 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.mfloorTaskStatus?.floor_task_name), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mfloorTaskStatus?.composite_task_list, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["grid-content basicInfo-materials", { checked: item.map_id == _ctx.mapId }]),
                    key: item.map_id,
                    onClick: ($event: any) => (_ctx.check(item.map_id))
                  }, [
                    _createVNode(_component_a_row, { align: "middle" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 12 }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", null, _toDisplayString(item.task_name), 1),
                            _createElementVNode("div", _hoisted_4, _toDisplayString(item.map_name), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_a_col, { span: 4 }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.floor_name), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_a_col, { span: 7 }, {
                          default: _withCtx(() => [
                            (item.task_state == 0)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.getTaskState(item.task_state, _ctx.t)), 1))
                              : (item.task_state == 1)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.getTaskState(item.task_state, _ctx.t)), 1))
                                : (item.task_state == 2)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.getTaskState(item.task_state, _ctx.t)), 1))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.getTaskState(item.task_state, _ctx.t)), 1))
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ], 10, _hoisted_3))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}